import { useState } from "react";
import type { PowerProject } from "../types";
import { TomTitlesTab } from "./tom/TomTitlesTab";
import { Z7Tab } from "./z7/Z7Tab";

// Zakładka „Dokumentacja” — dokumenty formalne projektu jako podzakładki
// (wzór podzakładek Doradcy AI). Dziś: Załącznik 7 ENERGA i TOM II tytułów prawnych;
// kolejne dokumenty (inne załączniki/ewidencje) dochodzą tu jako nowe podzakładki.
const SUBTABS = [
  { key: "z7", label: "Załącznik 7 (ewidencja zgód)" },
  { key: "tom2", label: "TOM II — Tytuły prawne" },
] as const;

type SubKey = (typeof SUBTABS)[number]["key"];

export function DocumentationTab({ connection }: { connection: PowerProject }) {
  const [sub, setSub] = useState<SubKey>("z7");
  return (
    <div className="mt-4">
      <div className="flex gap-2 text-xs font-mono">
        {SUBTABS.map((t) => (
          <button key={t.key} onClick={() => setSub(t.key)}
            className={`px-3 py-1.5 border ${sub === t.key
              ? "border-[var(--color-primary)] text-[var(--color-primary)]"
              : "border-[var(--color-border)] text-[var(--color-text-muted)]"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {sub === "z7" && <Z7Tab connection={connection} />}
      {sub === "tom2" && <TomTitlesTab connection={connection} />}
    </div>
  );
}
